<template>
    <div class="">
        <div class="month-picker-box m-auto pt-5 pb-2">
            <MonthPickerDropdown
                    v-model:inputValue="monthSelect"
                    :inputLbl="lbl.history.monthPicker"
                    @update:inputValue="onMonthSelect($event)"
            ></MonthPickerDropdown>
        </div>
        <HistoryItem
                v-for="(campaign) in purchases"
                :key="campaign.id"
                :purchase="campaign"
                @onClickPurchase="clickPurchase(campaign)"
        ></HistoryItem>

        <div v-if="isLoaded && purchases.length == 0" class="text-center py-20">
            Not found
        </div>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/Locale.js';
import ConfigManager from '@/config/ConfigManager.js';
import { CampaignType } from '@/helper/StaticValue.js';
import DatetimeHelper from '@/helper/DatetimeHelper';
//component
import HistoryItem from './HistoryItem.vue';
import MonthPickerDropdown from '@/components/Input/label/MonthPickerDropdown.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
//service
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import { PurchaseFilterConfigBuilder, PurchaseListConfigBuilder } from '@/core/History/config/HistoryConfigModel';

export default {
    name: 'HistoryList',
    mixins: [ModalMixin, LocaleMixin],
    components: {
        HistoryItem,
        MonthPickerDropdown,
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,
            purchases: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            isSerialLoading: false,
            monthSelect: new Date(),
        };
    },
    created: function () {
        // this.setupHistoryList();
    },
    methods: {
        setupHistoryList: async function (startDate, endDate) {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .setStartDate(startDate)
                .setEndDate(endDate)
                .create();
            this.listConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.filterConfig = filterListConfig;

            this.modal.loadingModal.show();
            await this.getList();
            this.modal.loadingModal.hide();
        },

        //#region history list
        onMonthSelect: function (value) {
            // Util.log('select month', value);
            let dateSelect = DatetimeHelper.stringToDate(value, 'yyyy-MM-dd');
            let endMonth = DatetimeHelper.getEndOfMonth(dateSelect.getFullYear(), dateSelect.getMonth() + 1);
            let startMonthFormat = DatetimeHelper.dateIsoFormat(dateSelect) + 'T00:00:00';
            let endMonthFormat = DatetimeHelper.dateIsoFormat(endMonth) + 'T23:59:59';
            this.setupHistoryList(startMonthFormat, endMonthFormat);
        },
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHistory.apiGetPurchase(this.listConfig, this.filterConfig).subscribe({
                    next: (purchases) => {
                        Util.log('history list', purchases);

                        this.listConfig.increstSkip();
                        //check is there are more campaign.
                        if (purchases && purchases.length < this.listConfig.defaultTopAmount) {
                            this.listConfig.setSeeMoreEnable(false);
                        }
                        //reinitialize list if no skip.
                        if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                            this.purchases = [];
                        }

                        for (var purchase of purchases) {
                            //TODO: Add GA Tracking.
                            this.purchases.push(purchase);
                        }

                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.purchases.length > 0 ? true : false;
                        resolve();
                    },
                    error: (err) => {
                        resolve();
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.errorApi(err);
                    },
                });
            });
        },

        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) {
                return;
            }

            if (this.isLoading) {
                return;
            }
            return this.getList();
        },
        //#endregion history list

        //#region action history
        clickPurchase: function (purchase) {
            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }

            // this.clickedIndex = index;
            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }

            this.isSerialLoading = true;
            BzbsHistory.apiRedeemDetail(purchase.redeemKey).subscribe({
                next: (result) => {
                    this.isSerialLoading = false;
                    purchase.updateAfterRedeem(result);

                    if (this.isShowSerialModal(purchase)) {
                        this.openSerial(purchase);
                    }
                    // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)
                    // else {
                    //     this.refreshList();
                    // }
                },
                error: (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                },
            });
        },

        openSerial: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            console.log('open serial');
            this.modal.serialModal
                    .clearModal()
                    .setSerial(serialModel)
                    .show();
            this.modal.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
        },

        openInterfaceHistory: function(purchase) {
            var sToken = Account.getTokenShuffle();
            var locale = Locale.getLocaleCode();
            var header = 'false';
            var theme = ConfigManager.getAppName();
            var returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == 'link') {
                var url = purchase.privilegeMessage;

                url = url.replace('<campaign_id>', purchase.id);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + returnUrl;

                window.location.replace(url);
                return;
            }

            // old default landing interface
            if (purchase.website && purchase.website.indexOf('starbucks') > 0) {
                let url = purchase.website +
                        '&token=' + sToken +
                        '&locale=' + locale +
                        '&RedeemKey=' + purchase.redeemKey +
                        '&header=' + header +
                        '&theme=' + theme +
                        '&return_url=' + returnUrl; // ReturnUrl;
                window.location.replace(url);
            } else if (purchase.website && purchase.website.indexOf('linesticker') > 0) {
                let url = purchase.website
                        + "&info2=" + purchase.info2
                        + "&info3=" + purchase.info3
                        + "&locale=" + locale
                        + "&return_url=" + returnUrl
                        + "&token=" + sToken
                        + "&is_history=true";
                window.location.replace(url);
            }
        },

        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') {
                return false;
            }
            if (purchase.expireIn && purchase.expireIn <= 0) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },

        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },
        //#endregion action history
    },
}
</script>
<style lang="scss" scoped>
    .month-picker-box {
        max-width: 250px;
    }
</style>
